export enum ENotificationType {
  CUSTOM_VALUE_BILLING_CREATED = 'CUSTOM_VALUE_BILLING_CREATED',
  FACEBOOK_AD_SENSE_ACCOUNT_BLOCKED = 'FACEBOOK_AD_SENSE_ACCOUNT_BLOCKED',
  PRODUCT_FIRST_TIME_ORDER = 'PRODUCT_FIRST_TIME_ORDER',
}
